var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.checkWidth() + ' ' + 'container'},[(_vm.loading)?[_c('div',{staticClass:"container vertical-center"},[_c('LoadingMDL')],1)]:[_c('CardPopupImg',{attrs:{"cardContent":_vm.content,"cardType":_vm.cardType2,"isModalVisible":_vm.isShow},on:{"updateUser":_vm.updateUser}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }